import { action } from 'typesafe-actions';
import { ICalculatorRules, ICreateUpdateCalculatorRules } from '../../types';
import { CalculatorRules } from './types';

// Get tip calculator rules
export const getCalculatorRulesRequest = (siteId: string) => action(CalculatorRules.GET_CALCULATOR_RULES_REQUEST, { siteId });
export const getCalculatorRulesSuccess = (response: ICalculatorRules) => action(CalculatorRules.GET_CALCULATOR_RULES_SUCCESS, response);
export const getCalculatorRulesError = (error: any) => action(CalculatorRules.GET_CALCULATOR_RULES_FAIL, error);

// Update tip calculator rules
export const updateCalculatorRulesRequest = (siteId: string, body: ICreateUpdateCalculatorRules, onSuccess?: () => void, successMessage?: string) =>
  action(CalculatorRules.UPDATE_CALCULATOR_RULES_REQUEST, { siteId, body, onSuccess, successMessage });
export const updateCalculatorRulesSuccess = (response: ICalculatorRules) => action(CalculatorRules.UPDATE_CALCULATOR_RULES_SUCCESS, response);
export const updateCalculatorRulesError = (error: any, failToast?: boolean) => action(CalculatorRules.UPDATE_CALCULATOR_RULES_FAIL, error, { failToast });

// Generate tip calculator rules
export const generateCalculatorRulesRequest = (siteId: string, onSuccess: (rules: ICreateUpdateCalculatorRules) => void, onError: (error: any) => void) =>
  action(CalculatorRules.GENERATE_CALCULATOR_RULES_REQUEST, { siteId, onSuccess, onError });
export const generateCalculatorRulesSuccess = (response: ICreateUpdateCalculatorRules) => action(CalculatorRules.GENERATE_CALCULATOR_RULES_SUCCESS, response);
export const generateCalculatorRulesError = (error: any, failToast?: boolean) => action(CalculatorRules.GENERATE_CALCULATOR_RULES_FAIL, error, { failToast });
